import moment from "moment";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const calculateTime = () => {
  const now = moment();
  const currentMonth = now.month();
  const currentYear = now.year();

  const lockStart = moment({
    year: currentYear,
    month: currentMonth,
    date: 26,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  }).local();

  // When locked (26th–end of month), next target is next month's 25th
  let targetDate;
  if (now.isSameOrAfter(lockStart)) {
    targetDate = moment({
      year: currentYear,
      month: currentMonth + 1,
      date: 25,
      hour: 23,
      minute: 59,
      second: 59,
      millisecond: 999
    }).local();
  } else {
    targetDate = moment({
      year: currentYear,
      month: currentMonth,
      date: 25,
      hour: 23,
      minute: 59,
      second: 59,
      millisecond: 999
    }).local();
  }

  const duration = moment.duration(targetDate.diff(now));
  const days = Math.floor(duration.asDays());
  let time = `${days} d`;

  if (duration.asMinutes() <= 60) {
    time = `${Math.floor(duration.asMinutes())} m`;
  } else if (duration.asHours() <= 24) {
    time = `${Math.floor(duration.asHours())} h`;
  }

  return time;
};

export const TimerForLastDay = () => {
  const { t } = useTranslation();
  const [timeLeft, setTimeLeft] = useState(calculateTime());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(calculateTime());
    }, 3600 * 1000);
    return () => clearInterval(interval);
  }, []);

  const now = moment();
  const isLocked = now.date() >= 26 || now.date() === 1; // 26th–end or 1st of next month

  return (
    <span style={{ color: "#757575", fontSize: "12px" }}>
      {isLocked ? (
        <>
          {t("time_to_pick_locked")}
          <b>
            <u>
              {" "}
              {moment()
                .add(1, "month")
                .startOf("month")
                .format("DD.MM")}
            </u>
          </b>
        </>
      ) : (
        <>
          {t("time_to_pick")}:{" "}
          <b>
            <u>{timeLeft}</u>
          </b>
        </>
      )}
    </span>
  );
};
